"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.addictionRelatedContraindicationMessages = exports.AddictionRelatedContraindication = void 0;
const schema_1 = require("../../../../schema");
var AddictionRelatedContraindication;
(function (AddictionRelatedContraindication) {
    AddictionRelatedContraindication["PRESENT"] = "PRESENT";
    AddictionRelatedContraindication["NONE"] = "NONE";
})(AddictionRelatedContraindication || (exports.AddictionRelatedContraindication = AddictionRelatedContraindication = {}));
exports.addictionRelatedContraindicationMessages = {
    [AddictionRelatedContraindication.PRESENT]: {
        id: "ltx.phaseI.consultations.addictionAssessment.addictionRelatedContraindication.PRESENT",
        defaultMessage: "Kontraindikáció"
    },
    [AddictionRelatedContraindication.NONE]: {
        id: "ltx.phaseI.consultations.addictionAssessment.addictionRelatedContraindication.NONE",
        defaultMessage: "Nincs kontraindikáció"
    }
};
const addictionRelatedContraindication = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AddictionRelatedContraindication.PRESENT),
    schema_1.Schema.singleChoiceItem(AddictionRelatedContraindication.NONE)
])
    .expiration(31104000)
    .interpretation({ vocab: "ltx", code: "addiction_assessment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ addictionRelatedContraindication })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "34043003" });
